import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { appHubLogin, appHubLoginOtp } from '../../store/auth'
import { Link, useNavigate } from 'react-router-dom'
import moment from 'moment'
import { useRef, useState } from 'react'
import PageLoader from '../../components/PageLoader/PageLoader'
function Login() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const currentTime = new Date()
	const OTP_TIME = 60
	const isloder = useSelector(state => state?.auth.isloder)
	const [otpSent, setOtpSent] = useState(false)
	const [timer, setTimer] = useState(OTP_TIME)
	const [otpValues, setOtpValues] = useState(Array(6).fill(''))
	const inputsRef = useRef([])
	const sentotpdata = useSelector(state => state?.auth?.Hub)

	const formik = useFormik({
		initialValues: {
			mobile: '',
			otp: '',
		},
		validationSchema: Yup.object({
			mobile: Yup.string()
				.min(10, 'Must be 10 characters')
				.max(10, 'Must be exactly 10 digits')
				.required('Required'),
			otp: otpSent
				? Yup.string()
						.required('OTP is required')
						.matches(/^\d{6}$/, 'OTP must be exactly 6 digits')
				: Yup.string().notRequired(),
		}),
		onSubmit: values => {
			// if (otpSent) {
			//   dispatch(
			//     appHubLoginOtp({
			//       mobile: values.mobile,
			//       otp: Number(values.otp),
			//       navigate: navigate,
			//     })
			//     // .then(() => {
			//     // navigate("/dashboard")
			//     // })
			//   );
			// } else {
			//   dispatch(
			//     appHubLogin({
			//       mobile: values.mobile,
			//       navigate: navigate,
			//     })
			//   );
			//   setOtpSent(true);
			// }
		},
	})

	const handlehubLoginOtp = () => {
		dispatch(
			appHubLoginOtp({
				mobile: formik.values.mobile,
				otp: Number(formik.values.otp),
				navigate: navigate,
			}),
		)
	}

	const handleSendOtp = () => {
		if (!formik.values.mobile || formik.errors.mobile) {
			formik.setTouched({ mobile: true })
			return
		}

		setTimer(OTP_TIME)
		setOtpSent(true)

		dispatch(
			appHubLogin({
				mobile: formik.values.mobile,
				navigate,
			}),
		)
	}

	const handleChangeotp = (e, index) => {
		const value = e.target.value
		if (!/^[0-9]?$/.test(value)) return
		const updatedOtp = [...otpValues]
		updatedOtp[index] = value
		setOtpValues(updatedOtp)
		formik.setFieldValue('otp', updatedOtp.join(''))
		if (value && index < 5) {
			inputsRef.current[index + 1].focus()
		}
	}

	const formatTime = seconds => {
		const m = Math.floor(seconds / 60)
		const s = seconds % 60
		return `${m}:${s < 10 ? '0' : ''}${s}`
	}

	const handleResendOtp = () => {
		setTimer(OTP_TIME)
		setOtpValues(Array(6).fill(''))
		formik.setFieldValue('otp', '')

		inputsRef.current.forEach(input => {
			if (input) input.value = ''
		})

		handleSendOtp()
	}

	useEffect(() => {
		if (!otpSent) return

		if (timer === 0) return

		const countdown = setInterval(() => {
			setTimer(prev => prev - 1)
		}, 1000)

		return () => clearInterval(countdown)
	}, [otpSent, timer])

	useEffect(() => {
		if (!otpSent) return

		if (sentotpdata?.otp && String(sentotpdata.otp).length === 6) {
			const autoOtp = String(sentotpdata.otp).split('')

			setOtpValues(autoOtp)
			formik.setFieldValue('otp', autoOtp.join(''))

			inputsRef.current[5]?.focus()
		}
	}, [sentotpdata?.otp, otpSent])

	return (
		<>
			{isloder && <PageLoader />}
			<div className="wrapper">
				<div className="block-center mt-4 wd-xl">
					<div className="card card-flat">
						<div className="card-header text-center">
							<Link to="#">
								<img
									className="block-center rounded"
									src="/img/logo3.png"
									alt="App Logo"
									style={{ width: '100px', height: '80px' }}
								/>
							</Link>
						</div>
						<div className="card-body ">
							<p className="text-center py-2">SIGN IN TO CONTINUE.</p>

							<form className="mb-3" onSubmit={formik.handleSubmit}>
								{otpSent ? (
									<>
										<div id="otp" className="d-flex form-otp text-center pb-3 gap-2">
											{[...Array(6)].map((_, index) => (
												<input
													key={index}
													ref={el => (inputsRef.current[index] = el)}
													className="text-center form-control gap-2"
													type="text"
													maxLength="1"
													value={otpValues[index]}
													onChange={e => handleChangeotp(e, index)}
													style={{
														width: '40px',
														height: '40px',
														fontSize: '20px',
														marginLeft: '8px',
														padding: '5px',
													}}
												/>
											))}
										</div>
										{formik.touched.otp && formik.errors.otp && (
											<div style={{ color: 'red' }}>{formik.errors.otp}</div>
										)}
										<button
											type="submit"
											onClick={handlehubLoginOtp}
											className="btn btn-primary btn-block"
										>
											Verify OTP & Login
										</button>
										{timer > 0 ? (
											<p className="text-center mt-2">Resend OTP in {formatTime(timer)}</p>
										) : (
											<button
												type="button"
												onClick={handleResendOtp}
												className="btn btn-link btn-block"
											>
												Resend OTP
											</button>
										)}
									</>
								) : (
									<div className="form-group">
										<div className="input-group with-focus">
											<input
												name="mobile"
												placeholder="+91 Enter Mobile Number"
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												value={formik.values.mobile}
												className="form-control"
											/>
											<div className="input-group-append">
												<span className="input-group-text text-mute bg-transparent border-left-0">
													<em className="fa fa-phone"></em>
												</span>
											</div>
										</div>
										{formik.touched.mobile && formik.errors.mobile && (
											<div style={{ color: 'red' }}>{formik.errors.mobile}</div>
										)}
									</div>
								)}
								{!otpSent && (
									<button
										type="button"
										onClick={handleSendOtp}
										className="btn btn-primary btn-block"
									>
										Send OTP
									</button>
								)}
							</form>
						</div>
					</div>
					<div className="p-3 text-center">
						<span className="mr-2">&copy;</span>
						<span className="mr-2">{moment(currentTime).format('YYYY')}</span>
						<span className="mr-2">-</span>
						<span>
							<a target={'_blank'}>apnamandal.com</a>
						</span>
						<br />
					</div>
				</div>
			</div>
		</>
	)
}

export default Login
